export default {
  default: () => import("/fire-bang-frontend/src/layouts/default.vue").then(m => m.default || m),
  plain: () => import("/fire-bang-frontend/src/layouts/plain.vue").then(m => m.default || m),
  promo: () => import("/fire-bang-frontend/src/layouts/promo.vue").then(m => m.default || m)
}